import { Search, Plus, Star, CalendarDays, Phone, Workflow, Upload, Home, ListChecks, KanbanSquare, LayoutList, BarChart3, FolderOpen, Zap, FileText, Wrench } from "lucide-react";

export const ONGLETS = {
  accueil: { label: "Accueil", path: "/" },
  tableaux: { label: "Tableaux de bord", path: "/tableaux" },
  outils: { label: "Mes outils", path: "/outils" },
  appels: { label: "Ma liste d'appels", path: "/appels" },
  pipeline: { label: "Pipeline", path: "/pipeline" },
  fiches: { label: "Fiches", path: "/fiches" },
  agenda: { label: "Agenda", path: "/agenda" },
  devis: { label: "Devis", path: "/devis" },
  automatisations: { label: "Automatisations", path: "/automatisations" },
  fichiers_prospection: { label: "Fichiers de prospection", path: "/fichiers-prospection" },
};

export const DOCK = {
  rechercher: { label: "Rechercher", icon: Search },
  nouvelle_fiche: { label: "Nouvelle fiche", icon: Plus },
  favoris: { label: "Favoris", icon: Star },
  agenda: { label: "Agenda", icon: CalendarDays, path: "/agenda" },
  appels: { label: "Appels", icon: Phone },
  automatisations: { label: "Automatisations", icon: Workflow, path: "/automatisations" },
  importer: { label: "Importer", icon: Upload },
};

export const SECTIONS = {
  compte: "Mon compte",
  utilisateurs: "Utilisateurs",
  partenaires: "Sociétés partenaires",
  processus: "Processus",
  champs: "Champs et tags",
  connexions: "Connexions",
  corbeille: "Corbeille",
  journal: "Historique",
  emails: "E-mails simulés",
  sauvegardes: "Sauvegardes",
  themes: "Thèmes",
  vues: "Vues",
  reserves: "Réserves",
  statuts: "Statuts d'appel",
  leads: "Entrées de leads",
  pieces: "Pièces par opération",
  modeles: "Modèles de messages",
  modeles_devis: "Modèles de devis",
  regles_automatisation: "Automatisations",
  commissions: "Commissions",
  ia: "IA",
  scripts: "Scripts d'appel",
  migration_nocrm: "Migration noCRM",
  partage: "Partage en lecture",
};

export const RAIL = [
  { code: "accueil", label: "Accueil", icon: Home, path: "/" },
  { code: "validations", label: "Validations", icon: ListChecks, path: "/validations", libre: true },
  { code: "appels", label: "Ma liste d'appels", icon: Phone, path: "/appels" },
  { code: "pipeline", label: "Pipeline", icon: KanbanSquare, path: "/pipeline" },
  { code: "fiches", label: "Fiches", icon: LayoutList, path: "/fiches" },
  { code: "agenda", label: "Agenda", icon: CalendarDays, path: "/agenda" },
  { code: "tableaux", label: "Tableaux de bord", icon: BarChart3, path: "/tableaux" },
  { code: "fichiers_prospection", label: "Fichiers de prospection", icon: FolderOpen, path: "/fichiers-prospection" },
  "sep",
  { code: "automatisations", label: "Automatisations", icon: Zap, path: "/automatisations" },
  { code: "devis", label: "Devis", icon: FileText, path: "/devis" },
  { code: "outils", label: "Mes outils", icon: Wrench, path: "/outils" },
];

export const entreesRail = (user) => {
  const ok = RAIL.filter((x) => x === "sep" || user.navigation.onglets.includes(x.code) || (x.libre && user.role !== "partenaire"));
  return ok.filter((x, i) => x !== "sep" || (i > 0 && i < ok.length - 1 && ok[i + 1] !== "sep"));
};

export const RACCOURCIS = ["nouvelle_fiche", "favoris", "importer"];
